






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class MobileCarat extends Vue {
  @Prop({ required: true })
  carat: string
}
